import { MainPlayer } from '@stores/krpPlayerStores';
import { $loadedScene } from '@stores/loadedStore';

function reOrderHotspots() {
  const player = MainPlayer.get();
  const scene = $loadedScene.getState();
  if (!scene?.hotspot || !player) return;
  scene.hotspot.forEach((x) => {
    player.updateHotspot({ id: x.id, zOrder: x.zOrder });
    const titleId = player.getHotspotById(x.id)?.titleHotspotId;
    if (titleId) {
      player.updateHotspot({ id: titleId, zOrder: x.zOrder });
    }
  });
}

export default reOrderHotspots;
